import axios from 'axios'
import {
  message
} from 'antd'

export const event = {logout() { }}

const instance = axios.create({
  baseURL: '/api/',
  timeout: 60000,
  transformResponse: [(res) => JSON.parse(res)]
})

instance.interceptors.response.use((res) => {
  if (res.data.code === 0) {
    return res.data.data || true
  }
  if (res.data.code === 401) {
    // return Promise.reject(res.data)
    event.logout()
    return Promise.reject(res.data)
  }
  message.error(res.data.msg || res.data.message)
  return Promise.reject(res)
}, error => {
  const status =
    (error.response &&
      error.response.status &&
      error.response.status) ||
    '';
  // const data = (error.response && error.response.data) || {};
  // if (data.message) {
  //     message.error(data.message);
  //     return Promise.reject(data.message);
  // }

  if (
    error.code == 'ECONNABORTED' &&
    error.message.indexOf('timeout') != -1
  ) {
    message.error('请求超时~~');
    return Promise.reject('请求超时~~');
  }
  if (status === 401) {
    message.error('登录过期,请重新登录');
    return Promise.reject('登录过期,请重新登录');
  }
  if (status === 404) {
    message.error('接口404报错');
    return Promise.reject('接口404报错');
  }
  if (status === 500) {
    console.log(error.response);
    message.error('服务器错误');
    return Promise.reject('接口404报错');
  }
  return Promise.reject('未知错误')
})

const getAuthHeader = () => {
  if (localStorage.local_broker_id) {
    return {
      brokerId: Number(localStorage.local_broker_id)
    }
  }
  return {}
}

export const get = (url, params) => instance({
  url,
  method: 'get',
  headers: getAuthHeader(),
  params
})

export const post = (url, data) => instance({
  url,
  method: 'post',
  headers: getAuthHeader(),
  data
})

export const put = (url, data) => instance({
  url,
  method: 'put',
  headers: getAuthHeader(),
  data
})
